var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;}\n"),React.createElement("g",{"id":"_","transform":"translate(-432 -309.87)","key":1},React.createElement("line",{"id":"Line_254","className":"st0","x1":"433.5","y1":"311.4","x2":"451.5","y2":"311.4"}))]);
}

Minus.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 21 3","style":{"enableBackground":"new 0 0 21 3"},"xmlSpace":"preserve"};

module.exports = Minus;

Minus.default = Minus;
